export default {
  statuses: {
    DRAFT: 'Brouillon',
    PUBLISHED: 'Publiée',
    REVIEWED_BY_COOPZONE: 'Révisée par Coop Zone',
    APPROBATION_BY_COOPZONE: 'En approbation par CZ',
    CANCELED: 'Annulée/Refusée',
  },
}
